import { render, staticRenderFns } from "./assetModelList.vue?vue&type=template&id=b072f074"
import script from "./assetModelList.vue?vue&type=script&lang=js"
export * from "./assetModelList.vue?vue&type=script&lang=js"
import style0 from "./assetModelList.vue?vue&type=style&index=0&id=b072f074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports